import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    section: {
      minWidth: 0,
      minHeight: 0,
      gridArea: 'content',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: Spacings.s16,
      marginTop: '24px',
      strokeWidth: '1px',
      [BreakPointsMedia.MD]: {
        gap: Spacings.s12,
      },
      [BreakPointsMedia.SM]: {
        gap: Spacings.s12,
      },
      [BreakPointsMedia.XS]: {
        gap: Spacings.s12,
      },
      [BreakPointsMedia.XXS]: {
        gap: Spacings.s12,
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      [BreakPointsMedia.MD]: {
        padding: 0,
      },
      [BreakPointsMedia.SM]: {
        padding: 0,
      },
      [BreakPointsMedia.XS]: {
        padding: 0,
      },
      [BreakPointsMedia.XXS]: {
        padding: 0,
      },
    },
    moreTemplates: {
      padding: [Spacings.s12, 0],
    },
    loadMoreWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'black',
      marginBottom: Spacings.s48,
      paddingTop: Spacings.s16,
      [BreakPointsMedia.SM]: {
        width: '100%',
      },
      [BreakPointsMedia.XS]: {
        width: '100%',
      },
      [BreakPointsMedia.XXS]: {
        width: '100%',
      },
    },
    loadMoreButton: {
      [BreakPointsMedia.SM]: {
        width: '100%',
      },
      [BreakPointsMedia.XS]: {
        width: '100%',
      },
      [BreakPointsMedia.XXS]: {
        width: '100%',
      },
    },
  },
  {
    name: 'content',
  },
);

export default useStyles;
